"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genResolveMarketIx = exports.genAddMarketListToCategoryIx = exports.genInitBracketAtomicTx = exports.genInitBracketTxs = exports.genInitBracketStepTwoTx = exports.genInitBracketStepTwoIx = exports.genInitBracketStepOneIx = exports.genAppendToFieldMarketMetadataIx = exports.genWriteToFieldMarketMetadataIx = exports.genWriteMarketEndToMetadataIx = exports.genInitMarketListIx = exports.genInitCategoryIx = exports.genInitMarketIx = exports.MAINNET_TREASURY = exports.DEVNET_TREASURY = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const misc_1 = require("./utils/misc");
const anchor_1 = require("@project-serum/anchor");
const initMarket_1 = require("./generated/instructions/initMarket");
const initCategory_1 = require("./generated/instructions/initCategory");
const initMarketList_1 = require("./generated/instructions/initMarketList");
const writeToFieldMarketMetadata_1 = require("./generated/instructions/writeToFieldMarketMetadata");
const writeMarketEndToMetadata_1 = require("./generated/instructions/writeMarketEndToMetadata");
const appendToFieldMarketMetadata_1 = require("./generated/instructions/appendToFieldMarketMetadata");
const initBracketStepOne_1 = require("./generated/instructions/initBracketStepOne");
const initBracketStepTwo_1 = require("./generated/instructions/initBracketStepTwo");
const addMarketListToCategory_1 = require("./generated/instructions/addMarketListToCategory");
const resolveMarket_1 = require("./generated/instructions/resolveMarket");
const consts_1 = require("./consts");
exports.DEVNET_TREASURY = new web3_js_1.PublicKey("9r1fxNbhQrd5ov8HSufrcYMqDhxphWuTjPfHdr1SDJ7L");
exports.MAINNET_TREASURY = new web3_js_1.PublicKey("3tsJBVh839KiHU24m9mqyD2yoxDRLUjH8ZdtqLsuKQod");
function genInitMarketIx(marketListId, marketId, authority) {
    const marketIdUint8Array = Uint8Array.from(marketId);
    const [marketList] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_list"), marketListId], consts_1.PROGRAM_ID_PUBKEY);
    const [market, bump] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market"), marketIdUint8Array, marketListId], consts_1.PROGRAM_ID_PUBKEY);
    const [marketMetadata] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_metadata"), marketIdUint8Array, marketListId], consts_1.PROGRAM_ID_PUBKEY);
    const ix = (0, initMarket_1.initMarket)({ marketId, bump }, {
        marketListAuthority: authority,
        marketList,
        market,
        marketMetadata,
        systemProgram: web3_js_1.SystemProgram.programId,
    });
    return { ix, marketList, market, bump, marketMetadata };
}
exports.genInitMarketIx = genInitMarketIx;
function genInitCategoryIx(categoryId, authority) {
    const [category, bump] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("category"), categoryId], consts_1.PROGRAM_ID_PUBKEY);
    const categoryIdArray = [...categoryId];
    const ix = (0, initCategory_1.initCategory)({ categoryId: categoryIdArray, bump }, {
        payer: authority,
        categoryAuthority: authority,
        category,
        systemProgram: web3_js_1.SystemProgram.programId,
    });
    return { ix, category };
}
exports.genInitCategoryIx = genInitCategoryIx;
function genInitMarketListIx(marketListId, authority, marketResolveAuthority) {
    const [marketList, bump] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_list"), marketListId], consts_1.PROGRAM_ID_PUBKEY);
    const ix = (0, initMarketList_1.initMarketList)({ marketListId: [...marketListId], bump }, {
        payer: authority,
        marketListAuthority: authority,
        metadataAuthority: authority,
        marketResolveAuthority: marketResolveAuthority,
        marketList,
        systemProgram: web3_js_1.SystemProgram.programId,
    });
    return { ix, marketList };
}
exports.genInitMarketListIx = genInitMarketListIx;
function genWriteMarketEndToMetadataIx(marketId, marketListId, marketEnd, authority) {
    const marketIdUint8Array = Uint8Array.from(marketId);
    let [marketMetadata] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_metadata"), marketIdUint8Array, marketListId], consts_1.PROGRAM_ID_PUBKEY);
    const ix = (0, writeMarketEndToMetadata_1.writeMarketEndToMetadata)({ marketEnd }, {
        marketMetadataAuthority: authority,
        marketMetadata,
    });
    return { ix, marketMetadata };
}
exports.genWriteMarketEndToMetadataIx = genWriteMarketEndToMetadataIx;
function genWriteToFieldMarketMetadataIx(marketId, marketListId, content, field, authority) {
    const marketIdUint8Array = Uint8Array.from(marketId);
    let [marketMetadata] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_metadata"), marketIdUint8Array, marketListId], consts_1.PROGRAM_ID_PUBKEY);
    const ix = (0, writeToFieldMarketMetadata_1.writeToFieldMarketMetadata)({ string: content, field }, {
        marketMetadataAuthority: authority,
        marketMetadata,
    });
    return { ix, marketMetadata };
}
exports.genWriteToFieldMarketMetadataIx = genWriteToFieldMarketMetadataIx;
function genAppendToFieldMarketMetadataIx(marketId, marketListId, content, field, authority) {
    let [marketMetadata] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_metadata"), Uint8Array.from(marketId), marketListId], consts_1.PROGRAM_ID_PUBKEY);
    const ix = (0, appendToFieldMarketMetadata_1.appendToFieldMarketMetadata)({ string: content, field }, {
        marketMetadataAuthority: authority,
        marketMetadata,
    });
    return { ix, marketMetadata };
}
exports.genAppendToFieldMarketMetadataIx = genAppendToFieldMarketMetadataIx;
function genInitBracketStepOneIx(marketListId, marketId, bracketId, usdcMint, authority) {
    const marketIdUint8Array = Uint8Array.from(marketId);
    const bracketIdUint8Array = Uint8Array.from(bracketId);
    let [marketList] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_list"), marketListId], consts_1.PROGRAM_ID_PUBKEY);
    let [market, marketBump] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market"), marketIdUint8Array, marketListId], consts_1.PROGRAM_ID_PUBKEY);
    let [bracket, bracketBump] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("bracket"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [usdcVault, usdcVaultBump] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("usdc_vault"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [yesMint, yesMintBump] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("yes_mint"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [noMint, noMintBump] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("no_mint"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [fUsdcMint, fUsdcMintBump] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("f_usdc_mint"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let bumps = {
        market: marketBump,
        bracket: bracketBump,
        usdcVault: usdcVaultBump,
        yesMint: yesMintBump,
        noMint: noMintBump,
        fUsdcMint: fUsdcMintBump,
    };
    let bracketIdToPass = [...bracketId];
    const stepOneAccounts = {
        marketListAuthority: authority,
        marketList,
        market,
        bracket,
        usdcMint,
        usdcVault,
        yesMint,
        noMint,
        fUsdcMint,
        systemProgram: web3_js_1.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    };
    const ix = (0, initBracketStepOne_1.initBracketStepOne)({
        bumps,
        bracketId: bracketIdToPass,
        bracketName: [...Buffer.from("".padEnd(20))],
    }, stepOneAccounts);
    return {
        ix,
        marketList,
        bracket,
        market,
        fUsdcMint,
        yesMint,
        bumps,
    };
}
exports.genInitBracketStepOneIx = genInitBracketStepOneIx;
async function genInitBracketStepTwoIx(marketListId, marketId, bracketId, authority, provider) {
    const marketIdUint8Array = Uint8Array.from(marketId);
    const bracketIdUint8Array = Uint8Array.from(bracketId);
    let [marketList] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_list"), marketListId], consts_1.PROGRAM_ID_PUBKEY);
    let [market] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market"), marketIdUint8Array, marketListId], consts_1.PROGRAM_ID_PUBKEY);
    let [bracket] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("bracket"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [yesMint] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("yes_mint"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [fUsdcMint] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("f_usdc_mint"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [serumMarket, serumMarketBump] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("serum_market"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [requestQueue, requestQueueBump] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("request_queue"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [coinVault, coinVaultBump] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("coin_vault"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [pcVault, pcVaultBump] = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from("pc_vault"),
        bracketIdUint8Array,
        marketIdUint8Array,
        marketListId,
    ], consts_1.PROGRAM_ID_PUBKEY);
    let [vaultSigner, vaultSignerNonce] = (0, misc_1.getVaultOwnerAndNonce)(serumMarket, misc_1.DEX_PID);
    let eventQueueKeypair = web3_js_1.Keypair.generate();
    let bidsKeypair = web3_js_1.Keypair.generate();
    let asksKeypair = web3_js_1.Keypair.generate();
    let serumBumps = {
        serumMarket: serumMarketBump,
        requestQueue: requestQueueBump,
        coinVault: coinVaultBump,
        pcVault: pcVaultBump,
        vaultSigner: vaultSignerNonce,
    };
    const ix = (0, initBracketStepTwo_1.initBracketStepTwo)({ serumBumps }, {
        marketListAuthority: authority,
        marketList,
        market,
        bracket,
        yesMint,
        fUsdcMint,
        serumMarket,
        requestQueue,
        coinVault,
        pcVault,
        vaultSigner,
        eventQueue: eventQueueKeypair.publicKey,
        bids: bidsKeypair.publicKey,
        asks: asksKeypair.publicKey,
        systemProgram: web3_js_1.SystemProgram.programId,
        tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        dexProgram: misc_1.DEX_PID,
        rent: web3_js_1.SYSVAR_RENT_PUBKEY,
    });
    const connection = provider.connection;
    const eventQueueSpace = 262144 + 12;
    const bidQueueSpace = 65536 + 12;
    const preInstructions = [
        web3_js_1.SystemProgram.createAccount({
            fromPubkey: provider.wallet.publicKey,
            newAccountPubkey: eventQueueKeypair.publicKey,
            lamports: await connection.getMinimumBalanceForRentExemption(eventQueueSpace),
            space: eventQueueSpace,
            programId: misc_1.DEX_PID,
        }),
        web3_js_1.SystemProgram.createAccount({
            fromPubkey: provider.wallet.publicKey,
            newAccountPubkey: bidsKeypair.publicKey,
            lamports: await connection.getMinimumBalanceForRentExemption(bidQueueSpace),
            space: bidQueueSpace,
            programId: misc_1.DEX_PID,
        }),
        web3_js_1.SystemProgram.createAccount({
            fromPubkey: provider.wallet.publicKey,
            newAccountPubkey: asksKeypair.publicKey,
            lamports: await connection.getMinimumBalanceForRentExemption(bidQueueSpace),
            space: bidQueueSpace,
            programId: misc_1.DEX_PID,
        }),
    ];
    return {
        ix,
        preInstructions,
        eventQueue: eventQueueKeypair,
        bids: bidsKeypair,
        asks: asksKeypair,
        serumBumps,
        serumMarket,
        bracket,
    };
}
exports.genInitBracketStepTwoIx = genInitBracketStepTwoIx;
async function genInitBracketStepTwoTx(marketListId, marketId, bracketId, authority, provider) {
    const { ix, preInstructions, eventQueue, bids, asks, serumBumps, serumMarket, bracket, } = await genInitBracketStepTwoIx(marketListId, marketId, bracketId, authority, provider);
    const tx = new web3_js_1.Transaction().add(...preInstructions, ix);
    return {
        tx,
        eventQueue,
        bids,
        asks,
        serumBumps,
        serumMarket,
        bracket,
    };
}
exports.genInitBracketStepTwoTx = genInitBracketStepTwoTx;
async function genInitBracketTxs(marketListId, marketId, bracketId, usdcMint, authority, provider) {
    const { ix: stepOneIx, bracket } = genInitBracketStepOneIx(marketListId, marketId, bracketId, usdcMint, authority);
    const stepOneTx = new web3_js_1.Transaction().add(stepOneIx);
    const { tx: stepTwoTx, eventQueue, bids, asks, serumMarket, } = await genInitBracketStepTwoTx(marketListId, marketId, bracketId, authority, provider);
    return { eventQueue, bids, asks, bracket, stepOneTx, stepTwoTx, serumMarket };
}
exports.genInitBracketTxs = genInitBracketTxs;
async function genInitBracketAtomicTx(marketListId, marketId, bracketId, usdcMint, authority, provider) {
    // this doesn't work until we get the transaction size down
    const additionalComputeBudgetInstruction = new web3_js_1.TransactionInstruction({
        keys: [],
        programId: new web3_js_1.PublicKey("ComputeBudget111111111111111111111111111111"),
        data: Buffer.from(Uint8Array.of(0, ...new anchor_1.BN(256000).toArray("le", 4))),
    });
    const { ix: stepOneIx, bracket } = await genInitBracketStepOneIx(marketListId, marketId, bracketId, usdcMint, authority);
    const { ix: stepTwoIx, preInstructions: stepTwoPreInstructions, eventQueue, bids, asks, } = await genInitBracketStepTwoIx(marketListId, marketId, bracketId, authority, provider);
    const tx = new web3_js_1.Transaction().add(additionalComputeBudgetInstruction, stepOneIx, ...stepTwoPreInstructions, stepTwoIx);
    return { eventQueue, bids, asks, bracket, tx };
}
exports.genInitBracketAtomicTx = genInitBracketAtomicTx;
function genAddMarketListToCategoryIx(categoryId, marketListId, authority) {
    let [category] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("category"), categoryId], consts_1.PROGRAM_ID_PUBKEY);
    let [marketList] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_list"), marketListId], consts_1.PROGRAM_ID_PUBKEY);
    const ix = (0, addMarketListToCategory_1.addMarketListToCategory)({
        authority: authority,
        category,
        marketList,
    });
    return { ix, category, marketList };
}
exports.genAddMarketListToCategoryIx = genAddMarketListToCategoryIx;
function genResolveMarketIx(winner, marketId, marketListId, authority) {
    let [marketList] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market_list"), marketListId], consts_1.PROGRAM_ID_PUBKEY);
    let [market] = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from("market"), Uint8Array.from(marketId), marketListId], consts_1.PROGRAM_ID_PUBKEY);
    return (0, resolveMarket_1.resolveMarket)({ winningBracket: winner }, {
        marketResolveAuthority: authority,
        marketList,
        market,
    });
}
exports.genResolveMarketIx = genResolveMarketIx;
//# sourceMappingURL=governance.js.map